export const airports  = [
  "Aalesund Airport (AES)",
  "Aarhus Airport (AAR)",
  "Abakan Airport (ABA)",
  "Abbotsford Airport (YXX)",
  "Aberdeen Airport (ABZ)",
  "Aberdeen Airport (ABR)",
  "Abha Airport (AHB)",
  "Abidjan Airport (ABJ)",
  "Abilene Airport (ABI)",
  "Abu Dhabi Airport (AUH)",
  "Abu Simbel Airport (ABS)",
  "Abuja Airport (ABV)",
  "Acapulco Airport (ACA)",
  "Accra Airport (ACC)",
  "Adana Airport (ADA)",
  "Addis Ababa Airport (ADD)",
  "Adelaide Airport (ADL)",
  "Aden Airport (ADE)",
  "Adler/Sochi Airport (AER)",
  "Agadir Airport (AGA)",
  "Agatti Island Airport (AGX)",
  "Agen Airport (AGF)",
  "Agra Airport (AGR)",
  "Aguadilla Airport (BQN)",
  "Aguascalientes Airport (AGU)",
  "Ahmedabad Airport (AMD)",
  "Aizawl Airport (AJL)",
  "Ajaccio Airport (AJA)",
  "Akita Airport (AXT)",
  "Akron/Canton Airport (CAK)",
  "Aktau Airport (SCO)",
  "Aktyubinsk Airport (AKX)",
  "Al Ain Airport (AAN)",
  "Al Arish Airport (AAC)",
  "Al Hoceima Airport (AHU)",
  "Alahsa Airport (HOF)",
  "AlAirport (Baha Airport (ABT)",
  "Albany Airport (ALH)",
  "Albany Airport (ALB)",
  "Albany Airport (ABY)",
  "Albuquerque Airport (ABQ)",
  "Albury Airport (ABX)",
  "Alderney Airport (ACI)",
  "Aleppo Airport (ALP)",
  "Alexandria Airport (ALY)",
  "Alexandria Airport (AEX)",
  "Alexandria Airport (HBE)",
  "Alexandroupolis Airport (AXD)",
  "Alghero Airport (AHO)",
  "Algiers Airport (ALG)",
  "Alicante Airport (ALC)",
  "Alice Springs Airport (ASP)",
  "Allentown/Bethlehem/Easton Airport (ABE)",
  "Almaty Airport (ALA)",
  "Almeria Airport (LEI)",
  "Alor Setar Airport (AOR)",
  "Alotau Airport (GUR)",
  "Alpena Airport (APN)",
  "Alta Airport (ALF)",
  "Altenrhein Airport (ACH)",
  "Altoona Airport (AOO)",
  "Amarillo Airport (AMA)",
  "Ambon Airport (AMQ)",
  "Amman Airport (AMM)",
  "Amritsar Airport (ATQ)",
  "Amsterdam Airport (AMS)",
  "Anapa Airport (AAQ)",
  "Anchorage Airport (ANC)",
  "Ancona Airport (AOI)",
  "Angelholm/Helsingborg Airport (AGH)",
  "Anguilla Airport (AXA)",
  "Ankara Airport (ESB)",
  "Annaba Airport (AAE)",
  "Annecy Airport (NCY)",
  "Antalya Airport (AYT)",
  "Antananarivo Airport (TNR)",
  "Antigua Airport (ANU)",
  "Antofagasta Airport (ANF)",
  "Antsiranana Airport (DIE)",
  "Aomori Airport (AOJ)",
  "Apia Airport (APW)",
  "Appleton Airport (ATW)",
  "Aqaba Airport (AQJ)",
  "Aracaju Airport (AJU)",
  "Arad Airport (ARW)",
  "Arba Mintch Airport (AMH)",
  "Arcata/Eureka Airport (ACV)",
  "Arequipa Airport (AQP)",
  "Arica Airport (ARI)",
  "Arkhangelsk Airport (ARH)",
  "Armenia Airport (AXM)",
  "Armidale Airport (ARM)",
  "Aruba Airport (AUA)",
  "Asahikawa Airport (AKJ)",
  "Asheville Airport (AVL)",
  "Ashgabat Airport (ASB)",
  "Asmara Airport (ASM)",
  "Aspen Airport (ASE)",
  "Assiut Airport (ATZ)",
  "Astana Airport (TSE)",
  "Astrakhan Airport (ASF)",
  "Asturias Airport (OVD)",
  "Asuncion Airport (ASU)",
  "Aswan Airport (ASW)",
  "Athens Airport (ATH)",
  "Atlanta Airport (ATL)",
  "Atyrau Airport (GUW)",
  "Auckland Airport (AKL)",
  "Augusta Airport (AGS)",
  "Aurangabad Airport (IXU)",
  "Aurillac Airport (AUR)",
  "Austin Airport (AUS)",
  "Avignon Airport (AVN)",
  "Ayers Rock Airport (AYQ)",
  "Bacau Airport (BCM)",
  "Badajoz Airport (BJZ)",
  "Bagdogra Airport (IXB)",
  "Baghdad Airport (BGW)",
  "Bagotville Airport (YBG)",
  "Bahia Blanca Airport (BHI)",
  "Bahrain Airport (BAH)",
  "Baia Mare Airport (BAY)",
  "Bakersfield Airport (BFL)",
  "Baku Airport (GYD)",
  "Balikpapan Airport (BPN)",
  "Ballina Airport (BNK)",
  "Balmaceda Airport (BBA)",
  "Baltimore Airport (BWI)",
  "Bamako Airport (BKO)",
  "Ban Me Thuot Airport (BMV)",
  "Banda Aceh Airport (BTJ)",
  "Bandar Lampung Airport (TKG)",
  "Bandar Seri Begawan Airport (BWN)",
  "Bangalore Airport (BLR)",
  "Bangkok Airport (BKK)",
  "Bangor Airport (BGR)",
  "Banja Luka Airport (BNX)",
  "Banjarmasin Airport (BDJ)",
  "Banjul Airport (BJL)",
  "Baotou Airport (BAV)",
  "Bar Harbor Airport (BHB)",
  "Barbados Airport (BGI)",
  "Barcelona Airport (BCN)",
  "Bari Airport (BRI)",
  "Bario Airport (BBN)",
  "Barnaul Airport (BAX)",
  "Barra Airport (BRR)",
  "Barrancabermeja Airport (EJA)",
  "Barranquilla Airport (BAQ)",
  "Barrow Airport (BRW)",
  "Basel/Mulhouse Airport (BSL)",
  "Basel/Mulhouse Airport (MLH)",
  "Basra Airport (BSR)",
  "Bastia Airport (BIA)",
  "Batam Airport (BTH)",
  "Bathurst Airport (ZBF)",
  "Batman Airport (BAL)",
  "Batna Airport (BLJ)",
  "Baton Rouge Airport (BTR)",
  "Batumi Airport (BUS)",
  "Beckley Airport (BKW)",
  "Beef Island Airport (EIS)",
  "Beihai Airport (BHY)",
  "Beijing Airport (PEK)",
  "Beira Airport (BEW)",
  "Beirut Airport (BEY)",
  "Bejaia Airport (BJA)",
  "Belem Airport (BEL)",
  "Belfast Airport (BHD)",
  "Belfast Airport (BFS)",
  "Belgorod Airport (EGO)",
  "Belgrade Airport (BEG)",
  "Belize City Airport (BZE)",
  "Bellingham Airport (BLI)",
  "Belo Horizonte Airport (CNF)",
  "Bemidji Airport (BJI)",
  "Benbecula Airport (BEB)",
  "Benghazi Airport (BEN)",
  "Bergen Airport (BGO)",
  "Bergerac Airport (EGC)",
  "Berlin Airport (TXL)",
  "Berlin Airport (SXF)",
  "Bermuda Airport (BDA)",
  "Berne Airport (BRN)",
  "Beziers Airport (BZR)",
  "Bhavnagar Airport (BHU)",
  "Bhopal Airport (BHO)",
  "Bhubaneswar Airport (BBI)",
  "Bhuj Airport (BHJ)",
  "Biarritz Airport (BIQ)",
  "Bilbao Airport (BIO)",
  "Billings Airport (BIL)",
  "Billund Airport (BLL)",
  "Bimini Airport (BIM)",
  "Binghamton Airport (BGM)",
  "Bintulu Airport (BTU)",
  "Birmingham Airport (BHX)",
  "Birmingham Airport (BHM)",
  "Bisha Airport (BHH)",
  "Bishkek Airport (FRU)",
  "Biskra Airport (BSK)",
  "Bismarck Airport (BIS)",
  "Blackpool Airport (BLK)",
  "Blagoveschensk Airport (BQS)",
  "Blantyre Airport (BLZ)",
  "Blenheim Airport (BHE)",
  "Bloemfontein Airport (BFN)",
  "BloomingtonAirport (Normal Airport (BMI)",
  "Boa Vista Airport (BVC)",
  "Boa Vista Airport (BVB)",
  "Bocas Del Toro Airport (BOC)",
  "Bodo Airport (BOO)",
  "Bodrum Airport (BJV)",
  "Bogota Airport (BOG)",
  "Boise Airport (BOI)",
  "Bologna Airport (BLQ)",
  "Bolzano/Bozen Airport (BZO)",
  "Bonaire Airport (BON)",
  "Bora Bora Airport (BOB)",
  "Bordeaux Airport (BOD)",
  "Bordeaux Airport (ZFQ)",
  "Bornholm Airport (RNN)",
  "Boston Airport (BOS)",
  "Bourgas Airport (BOJ)",
  "Bournemouth Airport (BOH)",
  "Bozeman Airport (BZN)",
  "Brainerd Airport (BRD)",
  "Brasilia Airport (BSB)",
  "Bratislava Airport (BTS)",
  "Brazzaville Airport (BZV)",
  "Bremen Airport (BRE)",
  "Brest Airport (BES)",
  "Brindisi Airport (BDS)",
  "Brisbane Airport (BNE)",
  "Bristol Airport (BRS)",
  "BriveAirport (LaAirport (Gaillarde Airport (BVE)",
  "Brno Airport (BRQ)",
  "Broome Airport (BME)",
  "Brownsville Airport (BRO)",
  "Brunswick Airport (BQK)",
  "Brussels Airport (BRU)",
  "Brussels Airport (ANR)",
  "Brussels Airport (CRL)",
  "Brussels Airport (ZYR)",
  "Bucaramanga Airport (BGA)",
  "Bucharest Airport (OTP)",
  "Bucharest Airport (BBU)",
  "Budapest Airport (BUD)",
  "Buenos Aires Airport (EZE)",
  "Buenos Aires Airport (AEP)",
  "Buffalo Airport (BUF)",
  "Bujumbura Airport (BJM)",
  "Bukhara Airport (BHK)",
  "Bulawayo Airport (BUQ)",
  "Bundaberg Airport (BDB)",
  "Burbank Airport (BUR)",
  "Burgos Airport (RGS)",
  "Burlington Airport (BTV)",
  "Bursa Airport (YEI)",
  "Busan Airport (PUS)",
  "Bydgoszcz Airport (BZG)",
  "Caen Airport (CFR)",
  "Cagliari Airport (CAG)",
  "Cairns Airport (CNS)",
  "Cairo Airport (CAI)",
  "Cajamarca Airport (CJA)",
  "Calama Airport (CJC)",
  "Calgary Airport (YYC)",
  "Cali Airport (CLO)",
  "Calvi Airport (CLY)",
  "Campbeltown Airport (CAL)",
  "Campeche Airport (CPE)",
  "Campo Grande Airport (CGR)",
  "Canakkale Airport (CKZ)",
  "Canberra Airport (CBR)",
  "Cancun Airport (CUN)",
  "Canouan Island Airport (CIW)",
  "Cantho Airport (VCA)",
  "Cape Town Airport (CPT)",
  "Caracas Airport (CCS)",
  "Carcassonne Airport (CCF)",
  "Cardiff Airport (CWL)",
  "Carnarvon Airport (CVQ)",
  "Cartagena Airport (CTG)",
  "Casablanca Airport (CMN)",
  "Casper Airport (CPR)",
  "Castlegar Airport (YCG)",
  "Castres Airport (DCM)",
  "Catania Airport (CTA)",
  "Cayenne Airport (CAY)",
  "Cebu Airport (CEB)",
  "Cedar City Airport (CDC)",
  "Cedar Rapids Airport (CID)",
  "Chambery Airport (CMF)",
  "Champaign Airport (CMI)",
  "Chandigarh Airport (IXC)",
  "Changchun Airport (CGQ)",
  "Changsha Airport (CSX)",
  "Changzhi Airport (CIH)",
  "Changzhou Airport (CZX)",
  "Chania Airport (CHQ)",
  "Chaoyang Airport (CHG)",
  "Charleston Airport (CRW)",
  "Charleston Airport (CHS)",
  "Charlotte Airport (CLT)",
  "Charlottesville Airport (CHO)",
  "Charlottetown Airport (YYG)",
  "Chattanooga Airport (CHA)",
  "Chelyabinsk Airport (CEK)",
  "Chengdu Airport (CTU)",
  "Chennai Airport (MAA)",
  "Chernovtsy Airport (CWC)",
  "Chiang Mai Airport (CNX)",
  "Chiang Rai Airport (CEI)",
  "Chicago Airport (ORD)",
  "Chicago Airport (MDW)",
  "Chiclayo Airport (CIX)",
  "Chico Airport (CIC)",
  "Chihuahua Airport (CUU)",
  "Chios Airport (JKH)",
  "Chisinau Airport (KIV)",
  "Chita Airport (HTA)",
  "Chittagong Airport (CGP)",
  "Chlef Airport (CFK)",
  "Chongqing Airport (CKG)",
  "Christchurch Airport (CHC)",
  "Cincinnati Airport (CVG)",
  "Ciudad Del Carmen Airport (CME)",
  "Ciudad del Este Airport (AGT)",
  "Ciudad Juarez Airport (CJS)",
  "Ciudad Obregon Airport (CEN)",
  "Clarksburg Airport (CKB)",
  "ClermontAirport (Ferrand Airport (CFE)",
  "Cleveland Airport (CLE)",
  "Cloncurry Airport (CNJ)",
  "Cluj Airport (CLJ)",
  "Cochabamba Airport (CBB)",
  "Cody Airport (COD)",
  "Coffs Harbour Airport (CFS)",
  "Coimbatore Airport (CJB)",
  "Colima Airport (CLQ)",
  "College Station Airport (CLL)",
  "Cologne Airport (CGN)",
  "Colombo Airport (CMB)",
  "Colorado Springs Airport (COS)",
  "Columbia Airport (CAE)",
  "Columbia Airport (COU)",
  "Columbus Airport (CMH)",
  "Columbus Airport (GTR)",
  "Columbus Airport (CSG)",
  "Comox Airport (YQQ)",
  "Concepcion Airport (CCP)",
  "Constanta Airport (CND)",
  "Constantine Airport (CZL)",
  "Copenhagen Airport (CPH)",
  "Copiapo Airport (CPO)",
  "Cordoba Airport (COR)",
  "Cork Airport (ORK)",
  "Corpus Christi Airport (CRP)",
  "Cotonou Airport (COO)",
  "Cozumel Airport (CZM)",
  "Craig Cove Airport (CCV)",
  "Craiova Airport (CRA)",
  "Cranbrook Airport (YXC)",
  "Crotone Airport (CRV)",
  "Cucuta Airport (CUC)",
  "Cuenca Airport (CUE)",
  "Cuiaba Airport (CGB)",
  "Culiacan Airport (CUL)",
  "Curacao Airport (CUR)",
  "Curitiba Airport (CWB)",
  "Cuzco Airport (CUZ)",
  "Da Nang Airport (DAD)",
  "Daegu Airport (TAE)",
  "Dakar Airport (DKR)",
  "Dakhla Airport (VIL)",
  "Dalaman Airport (DLM)",
  "Dalat Airport (DLI)",
  "Dalian Airport (DLC)",
  "Dallas/Fort Worth Airport (DFW)",
  "Dallas/Fort Worth Airport (DAL)",
  "Damascus Airport (DAM)",
  "Dammam Airport (DMM)",
  "Dandong Airport (DDG)",
  "Dar Es Salaam Airport (DAR)",
  "Darwin Airport (DRW)",
  "Datong Airport (DAT)",
  "Davao Airport (DVO)",
  "David Airport (DAV)",
  "Dayong Airport (DYG)",
  "Dayton Airport (DAY)",
  "Daytona Beach Airport (DAB)",
  "Deauville Airport (DOL)",
  "Debrecen Airport (DEB)",
  "Deer Lake Airport (YDF)",
  "Dehra Dun Airport (DED)",
  "Delhi Airport (DEL)",
  "Denizli Airport (DNZ)",
  "Denpasar Bali Airport (DPS)",
  "Denver Airport (DEN)",
  "Des Moines Airport (DSM)",
  "Detroit Airport (DTW)",
  "Devonport Airport (DPO)",
  "Dhaka Airport (DAC)",
  "Dharamsala Airport (DHM)",
  "Dibrugarh Airport (DIB)",
  "Dickinson Airport (DIK)",
  "Dijon Airport (DIJ)",
  "Dili Airport (DIL)",
  "Dimapur Airport (DMU)",
  "Dinard Airport (DNR)",
  "Dire Dawa Airport (DIR)",
  "Diyarbakir Airport (DIY)",
  "Djerba Airport (DJE)",
  "Djibouti Airport (JIB)",
  "Dnepropetrovsk Airport (DNK)",
  "Doha Airport (DOH)",
  "Dominica Airport (DOM)",
  "Doncaster Airport (DSA)",
  "Donegal Airport (CFN)",
  "Donetsk Airport (DOK)",
  "Dongsheng Airport (DSN)",
  "Dortmund Airport (DTM)",
  "Dothan Airport (DHN)",
  "Douala Airport (DLA)",
  "Dresden Airport (DRS)",
  "Dubai Airport (DXB)",
  "Dubai Airport (XNB)",
  "Dubbo Airport (DBO)",
  "Dublin Airport (DUB)",
  "Dubrovnik Airport (DBV)",
  "Dubuque Airport (DBQ)",
  "Duluth/Superior Airport (DLH)",
  "Dundee Airport (DND)",
  "Dunedin Airport (DUD)",
  "Dunhuang Airport (DNH)",
  "Durango Airport (DGO)",
  "Durango Airport (DRO)",
  "Durban Airport (DUR)",
  "Durham Tees Valley Airport (MME)",
  "Dushanbe Airport (DYU)",
  "Dusseldorf Airport (DUS)",
  "Dusseldorf Airport (NRN)",
  "Dzaoudzi Airport (DZA)",
  "East London Airport (ELS)",
  "Easter Island Airport (IPC)",
  "Eau Claire Airport (EAU)",
  "Edinburgh Airport (EDI)",
  "Edmonton Airport (YEG)",
  "Eindhoven Airport (EIN)",
  "Ekaterinburg Airport (SVX)",
  "El Calafate Airport (FTE)",
  "El Paso Airport (ELP)",
  "El Vigia Airport (VIG)",
  "Elat Airport (ETH)",
  "Elazig Airport (EZS)",
  "Elmira/Corning Airport (ELM)",
  "Emerald Airport (EMD)",
  "Entebbe/Kampala Airport (EBB)",
  "Erbil Airport (EBL)",
  "Ercan Airport (ECN)",
  "Erfurt Airport (ERF)",
  "Erie Airport (ERI)",
  "Errachidia Airport (ERH)",
  "Erzincan Airport (ERC)",
  "Erzurum Airport (ERZ)",
  "Esbjerg Airport (EBJ)",
  "Esperance Airport (EPR)",
  "Espiritu Santo Airport (SON)",
  "Essaouira Airport (ESU)",
  "Eugene Airport (EUG)",
  "Evansville Airport (EVV)",
  "Exeter Airport (EXT)",
  "Fairbanks Airport (FAI)",
  "Fakarava Airport (FAV)",
  "Fargo Airport (FAR)",
  "Farmington Airport (FMN)",
  "Faro Airport (FAO)",
  "Fayetteville Airport (FAY)",
  "Fayetteville Airport (XNA)",
  "Fergana Airport (FEG)",
  "Fernando De Noronha Airport (FEN)",
  "Fez Airport (FEZ)",
  "Figari Airport (FSC)",
  "Flint Airport (FNT)",
  "Florence Airport (FLR)",
  "Florence Airport (FLO)",
  "Flores Airport (FRS)",
  "Flores Island Airport (FLW)",
  "Florianopolis Airport (FLN)",
  "Foggia Airport (FOG)",
  "Formosa Airport (FMA)",
  "Fort Dauphin Airport (FTU)",
  "Fort de France Airport (FDF)",
  "Fort Lauderdale Airport (FLL)",
  "Fort McMurray Airport (YMM)",
  "Fort Myers Airport (RSW)",
  "Fort Simpson Airport (YFS)",
  "Fort Smith Airport (FSM)",
  "Fort St John Airport (YXJ)",
  "Fort Wayne Airport (FWA)",
  "Fortaleza Airport (FOR)",
  "Frankfurt Airport (FRA)",
  "Frankfurt Airport (HHN)",
  "Fredericton Airport (YFC)",
  "Freeport Airport (FPO)",
  "Freetown Airport (FNA)",
  "Fresno Airport (FAT)",
  "Friedrichshafen Airport (FDH)",
  "Fuerteventura Airport (FUE)",
  "Fukuoka Airport (FUK)",
  "Fukushima Airport (FKS)",
  "Funafuti Atol Airport (FUN)",
  "Funchal Airport (FNC)",
  "Futuna Airport (FUT)",
  "Fuzhou Airport (FOC)",
  "Gaborone Airport (GBE)",
  "Gainesville Airport (GNV)",
  "Galapagos Islands Airport (GPS)",
  "Galway Airport (GWY)",
  "Gander Airport (YQX)",
  "Ganzhou Airport (KOW)",
  "Gassim Airport (ELQ)",
  "Gaya Airport (GAY)",
  "Gaziantep Airport (GZT)",
  "Gdansk Airport (GDN)",
  "Gelendzik Airport (GDZ)",
  "Geneva Airport (GVA)",
  "Genoa Airport (GOA)",
  "George Airport (GRJ)",
  "George Town Airport (GGT)",
  "Georgetown Airport (GEO)",
  "Geraldton Airport (GET)",
  "Gerona Airport (GRO)",
  "Gibraltar Airport (GIB)",
  "Gillette Airport (GCC)",
  "Gisborne Airport (GIS)",
  "Gizo Airport (GZO)",
  "Gladstone Airport (GLT)",
  "Glasgow Airport (GLA)",
  "Glasgow Airport (GGW)",
  "Goa Airport (GOI)",
  "Goiania Airport (GYN)",
  "Gold Coast Airport (OOL)",
  "Gondar Airport (GDQ)",
  "Goose Bay Airport (YYR)",
  "Goroka Airport (GKA)",
  "Gothenburg Airport (GOT)",
  "Gothenburg Airport (GSE)",
  "Gove Airport (GOV)",
  "Governors Harbour Airport (GHB)",
  "Granada Airport (GRX)",
  "Grand Canyon Airport (FLG)",
  "Grand Cayman Island Airport (GCM)",
  "Grand Forks Airport (GFK)",
  "Grand Island Airport (GRI)",
  "Grand Junction Airport (GJT)",
  "Grand Rapids Airport (GRR)",
  "Grande Prairie Airport (YQU)",
  "Graz Airport (GRZ)",
  "Great Falls Airport (GTF)",
  "Green Bay Airport (GRB)",
  "Greensboro/High Point Airport (GSO)",
  "Greenville Airport (GSP)",
  "Greenville Airport (PGV)",
  "Grenada Airport (GND)",
  "Groningen Airport (GRQ)",
  "Guadalajara Airport (GDL)",
  "Guam Airport (GUM)",
  "Guangzhou Airport (CAN)",
  "Guatemala City Airport (GUA)",
  "Guayaquil Airport (GYE)",
  "Guaymas Airport (GYM)",
  "Guernsey Airport (GCI)",
  "Guilin Airport (KWL)",
  "Guiyang Airport (KWE)",
  "Gulfport/Biloxi Airport (GPT)",
  "Gunnison Airport (GUC)",
  "Gurayat Airport (URY)",
  "Guwahati Airport (GAU)",
  "Haikou Airport (HAK)",
  "Hail Airport (HAS)",
  "Hailar Airport (HLD)",
  "Haiphong Airport (HPH)",
  "Hakodate Airport (HKD)",
  "Halifax Airport (YHZ)",
  "Hamburg Airport (HAM)",
  "Hamilton Airport (HLZ)",
  "Hamilton Island Airport (HTI)",
  "Hancock Airport (CMX)",
  "Hangzhou Airport (HGH)",
  "Hanoi Airport (HAN)",
  "Hanover Airport (HAJ)",
  "Harare Airport (HRE)",
  "Harbin Airport (HRB)",
  "Harlingen Airport (HRL)",
  "Harrisburg Airport (MDT)",
  "HarstadAirport (Narvik Airport (EVE)",
  "Hartford Airport (BDL)",
  "Hat Yai Airport (HDY)",
  "Hatay Airport (HTY)",
  "Haugesund Airport (HAU)",
  "Havana Airport (HAV)",
  "Hefei Airport (HFE)",
  "Heihe Airport (HEK)",
  "Helena Airport (HLN)",
  "Helsinki Airport (HEL)",
  "Heraklion Airport (HER)",
  "Hermosillo Airport (HMO)",
  "Hervey Bay Airport (HVB)",
  "Hilo Airport (ITO)",
  "Hilton Head Island Airport (HHH)",
  "Hiroshima Airport (HIJ)",
  "Ho Chi Minh City Airport (SGN)",
  "Hobart Airport (HBA)",
  "Hoedspruit Airport (HDS)",
  "Hof Airport (HOQ)",
  "Hohhot Airport (HET)",
  "Hokitika Airport (HKK)",
  "Hong Kong Airport (HKG)",
  "Honiara Airport (HIR)",
  "Honolulu Airport (HNL)",
  "Horn Island Airport (HID)",
  "Horta Airport (HOR)",
  "Hotan Airport (HTN)",
  "Houeisay Airport (HOE)",
  "Houston Airport (IAH)",
  "Houston Airport (HOU)",
  "Huahine Airport (HUH)",
  "Huangyan Airport (HYN)",
  "Huatulco Airport (HUX)",
  "Hubli Airport (HBX)",
  "Hue Airport (HUI)",
  "Humberside Airport (HUY)",
  "Huntington Airport (HTS)",
  "Huntsville Airport (HSV)",
  "Hurghada Airport (HRG)",
  "Iasi Airport (IAS)",
  "Ibague Airport (IBE)",
  "Ibiza Airport (IBZ)",
  "Idaho Falls Airport (IDA)",
  "Iguassu Falls Airport (IGU)",
  "Iguazu Airport (IGR)",
  "Ikaria Island Airport (JIK)",
  "Iles de la Madeleine Airport (YGR)",
  "Ilheus Airport (IOS)",
  "Imperatriz Airport (IMP)",
  "Imphal Airport (IMF)",
  "Indianapolis Airport (IND)",
  "Indore Airport (IDR)",
  "Inhambane Airport (INH)",
  "Innsbruck Airport (INN)",
  "International Falls Airport (INL)",
  "Invercargill Airport (IVC)",
  "Inverness Airport (INV)",
  "Inyokern Airport (IYK)",
  "Ioannina Airport (IOA)",
  "Ipoh Airport (IPH)",
  "Iqaluit Airport (YFB)",
  "Iquique Airport (IQQ)",
  "Iquitos Airport (IQT)",
  "Irkutsk Airport (IKT)",
  "Ishigaki Airport (ISG)",
  "Islamabad Airport (ISB)",
  "Islay Airport (ILY)",
  "Isle Of Man Airport (IOM)",
  "Istanbul Airport (IST)",
  "Istanbul Airport (SAW)",
  "Ithaca Airport (ITH)",
  "Ivalo Airport (IVL)",
  "IvanoAirport (Frankovsk Airport (IFO)",
  "Ixtapa/Zihuatanejo Airport (ZIH)",
  "Izmir Airport (ADB)",
  "Jabalpur Airport (JLR)",
  "Jackson Airport (JAC)",
  "Jackson Airport (JAN)",
  "Jacksonville Airport (JAX)",
  "Jacksonville Airport (OAJ)",
  "Jaipur Airport (JAI)",
  "Jakarta Airport (CGK)",
  "Jambi Airport (DJB)",
  "Jamestown Airport (JMS)",
  "Jamestown Airport (JHW)",
  "Jammu Airport (IXJ)",
  "Jayapura Airport (DJJ)",
  "Jeddah Airport (JED)",
  "Jeju Airport (CJU)",
  "Jerez de la Frontera Airport (XRY)",
  "Jersey Airport (JER)",
  "Jiayuguan Airport (JGN)",
  "Jijel Airport (GJL)",
  "Jinan Airport (TNA)",
  "Jingdezhen Airport (JDZ)",
  "Jinghong Airport (JHG)",
  "Jinjiang Airport (JJN)",
  "Jinju Airport (HIN)",
  "Joao Pessoa Airport (JPA)",
  "Jodhpur Airport (JDH)",
  "Joensuu Airport (JOE)",
  "Johannesburg Airport (JNB)",
  "Johannesburg Airport (HLA)",
  "Johor Bahru Airport (JHB)",
  "Joinville Airport (JOI)",
  "Jonkoping Airport (JKG)",
  "Joplin Airport (JLN)",
  "Jorhat Airport (JRH)",
  "Jouf Airport (AJF)",
  "Juliaca Airport (JUL)",
  "Juneau Airport (JNU)",
  "Jyvaskyla Airport (JYV)",
  "Kabul Airport (KBL)",
  "Kagoshima Airport (KOJ)",
  "Kahului Airport (OGG)",
  "Kaitaia Airport (KAT)",
  "Kajaani Airport (KAJ)",
  "Kalamata Airport (KLX)",
  "Kalamazoo Airport (AZO)",
  "Kalgoorlie Airport (KGI)",
  "Kaliningrad Airport (KGD)",
  "Kalispell Airport (FCA)",
  "Kalmar Airport (KLR)",
  "Kamloops Airport (YKA)",
  "Kandla Airport (IXY)",
  "Kano Airport (KAN)",
  "Kansas City Airport (MCI)",
  "Kaohsiung Airport (KHH)",
  "Kapalua Airport (JHM)",
  "Karachi Airport (KHI)",
  "Karaganda Airport (KGF)",
  "Karlovy Vary Airport (KLV)",
  "Karlsruhe/Baden Baden Airport (FKB)",
  "Karlstad Airport (KSD)",
  "Karpathos Airport (AOK)",
  "Karratha Airport (KTA)",
  "Kars Airport (KSY)",
  "Karshi Airport (KSQ)",
  "Karup Airport (KRP)",
  "Kashi Airport (KHG)",
  "Kasos Island Airport (KSJ)",
  "Kastelorizo Airport (KZS)",
  "Kathmandu Airport (KTM)",
  "Katowice Airport (KTW)",
  "Kauai Island Airport (LIH)",
  "Kaunas Airport (KUN)",
  "Kavala Airport (KVA)",
  "Kayseri Airport (ASR)",
  "Kazan Airport (KZN)",
  "Kearney Airport (EAR)",
  "Kefallinia Airport (EFL)",
  "Kelowna Airport (YLW)",
  "Kemerovo Airport (KEJ)",
  "Kemi/Tornio Airport (KEM)",
  "Kerikeri Airport (KKE)",
  "Kerkyra Airport (CFU)",
  "Kerry County Airport (KIR)",
  "Ketchikan Airport (KTN)",
  "Key West Airport (EYW)",
  "Khabarovsk Airport (KHV)",
  "Khajuraho Airport (HJR)",
  "Kharkov Airport (HRK)",
  "Khasab Airport (KHS)",
  "Khon Kaen Airport (KKC)",
  "Kiev Airport (KBP)",
  "Kigali Airport (KGL)",
  "Kilimanjaro Airport (JRO)",
  "Killeen Airport (GRK)",
  "Kimberley Airport (KIM)",
  "Kingston Airport (YGK)",
  "Kingston Airport (KIN)",
  "Kinshasa Airport (FIH)",
  "Kirkenes Airport (KKN)",
  "Kirkwall Airport (KOI)",
  "Kiruna Airport (KRN)",
  "Kisumu Airport (KIS)",
  "Kithira Airport (KIT)",
  "Kittila Airport (KTT)",
  "Klagenfurt Airport (KLU)",
  "Klaipeda/Palanga Airport (PLQ)",
  "Knock Airport (NOC)",
  "Knoxville Airport (TYS)",
  "Kochi Airport (COK)",
  "Kochi Airport (KCZ)",
  "Kodiak Airport (ADQ)",
  "Koh Samui Airport (USM)",
  "Kokkola/Pietarsaari Airport (KOK)",
  "Kolhapur Airport (KLH)",
  "Kolkata Airport (CCU)",
  "Komatsu Airport (KMQ)",
  "Kona Airport (KOA)",
  "Konya Airport (KYA)",
  "Koror Airport (ROR)",
  "Kos Airport (KGS)",
  "Kosice Airport (KSC)",
  "Kostanay Airport (KSN)",
  "Kota Bharu Airport (KBR)",
  "Kota Kinabalu Airport (BKI)",
  "Kozhikode Airport (CCJ)",
  "Krabi Airport (KBV)",
  "Krakow Airport (KRK)",
  "Krasnodar Airport (KRR)",
  "Krasnoyarsk Airport (KJA)",
  "Kristiansand Airport (KRS)",
  "Kristiansund Airport (KSU)",
  "Kuala Lumpur Airport (KUL)",
  "Kuala Lumpur Airport (SZB)",
  "Kuala Terengganu Airport (TGG)",
  "Kuantan Airport (KUA)",
  "Kuching Airport (KCH)",
  "Kudat Airport (KUD)",
  "Kulu Airport (KUU)",
  "Kumamoto Airport (KMJ)",
  "Kunming Airport (KMG)",
  "Kununurra Airport (KNX)",
  "Kuopio Airport (KUO)",
  "Kupang Airport (KOE)",
  "Kuressaare Airport (URE)",
  "Kushiro Airport (KUH)",
  "Kuusamo Airport (KAO)",
  "Kuwait Airport (KWI)",
  "Kwajalein Airport (KWA)",
  "La Ceiba Airport (LCE)",
  "La Coruna Airport (LCG)",
  "La Crosse Airport (LSE)",
  "La Paz Airport (LPB)",
  "La Paz Airport (LAP)",
  "La Rochelle Airport (LRH)",
  "La Romana Airport (LRM)",
  "La Serena Airport (LSC)",
  "Laayoune Airport (EUN)",
  "Labasa Airport (LBS)",
  "Labuan Airport (LBU)",
  "Lafayette Airport (LFT)",
  "Lagos Airport (LOS)",
  "Lahad Datu Airport (LDU)",
  "Lahore Airport (LHE)",
  "Lake Charles Airport (LCH)",
  "Lalibela Airport (LLI)",
  "Lamap Airport (LPM)",
  "Lamezia Terme Airport (SUF)",
  "Lampedusa Airport (LMP)",
  "Lanai City Airport (LNY)",
  "Langkawi Airport (LGK)",
  "Lannion Airport (LAI)",
  "Lansing Airport (LAN)",
  "Lanzarote Airport (ACE)",
  "Lanzhou Airport (LHW)",
  "Lappeenranta Airport (LPP)",
  "Laramie Airport (LAR)",
  "Laredo Airport (LRD)",
  "Larnaca Airport (LCA)",
  "Las Palmas Airport (LPA)",
  "Las Piedras Airport (LSP)",
  "Las Vegas Airport (LAS)",
  "Launceston Airport (LST)",
  "Laurel Airport (PIB)",
  "Lawton Airport (LAW)",
  "Lazaro Cardenas Airport (LZC)",
  "Le Havre Airport (LEH)",
  "Learmonth Airport (LEA)",
  "Leeds Bradford Airport (LBA)",
  "Leh Airport (IXL)",
  "Leipzig/Halle Airport (LEJ)",
  "Leon Airport (LEN)",
  "Leon/Guanajuato Airport (BJX)",
  "Leros Airport (LRS)",
  "Lethbridge Airport (YQL)",
  "Lewiston Airport (LWS)",
  "Lexington Airport (LEX)",
  "Lhasa Airport (LXA)",
  "Lianyungang Airport (LYG)",
  "Liberal Airport (LBL)",
  "Liberia Airport (LIR)",
  "Libreville Airport (LBV)",
  "Lille Airport (LIL)",
  "Lille Airport (XDB)",
  "Lilongwe Airport (LLW)",
  "Lima Airport (LIM)",
  "Limbang Airport (LMN)",
  "Limnos Airport (LXS)",
  "Limoges Airport (LIG)",
  "Lincoln Airport (LNK)",
  "Linkoping Airport (LPI)",
  "Linz Airport (LNZ)",
  "Lisbon Airport (LIS)",
  "Little Cayman Airport (LYB)",
  "Little Rock Airport (LIT)",
  "Liuzhou Airport (LZH)",
  "Liverpool Airport (LPL)",
  "Livingstone Airport (LVI)",
  "Ljubljana Airport (LJU)",
  "London All Airport (LON)",
  "London Heathrow Airport (LHR)",
  "London Gatwick Airport (LGW)",
  "London Stansted Airport (STN)",
  "London City Airport (LCY)",
  "London Luton Airport (LTN)",
  "Londonderry Airport (LDY)",
  "Londrina Airport (LDB)",
  "Long Beach Airport (LGB)",
  "Long Island MacArthur Airport (ISP)",
  "Longreach Airport (LRE)",
  "Longyearbyen Airport (LYR)",
  "Lord Howe Island Airport (LDH)",
  "Loreto Airport (LTO)",
  "Lorient Airport (LRT)",
  "Los Angeles Airport (LAX)",
  "Los Mochis Airport (LMM)",
  "Louisville Airport (SDF)",
  "Lourdes/Tarbes Airport (LDE)",
  "Luanda Airport (LAD)",
  "Luang Namtha Airport (LXG)",
  "Luang Prabang Airport (LPQ)",
  "Lubbock Airport (LBB)",
  "Lubumbashi Airport (FBM)",
  "Lucknow Airport (LKO)",
  "Ludhiana Airport (LUH)",
  "Lugano Airport (LUG)",
  "Lugansk Airport (VSG)",
  "Lulea Airport (LLA)",
  "Luoyang Airport (LYA)",
  "Lusaka Airport (LUN)",
  "Luxembourg Airport (LUX)",
  "Luxi Airport (LUM)",
  "Luxor Airport (LXR)",
  "Luzon Island Airport (CRK)",
  "Lviv Airport (LWO)",
  "Lynchburg Airport (LYH)",
  "Lyon Airport (LYS)",
  "Lyon Airport (GNB)",
  "Lyon Airport (XYD)",
  "Maastricht Airport (MST)",
  "Macau Airport (MFM)",
  "Maceio Airport (MCZ)",
  "Mackay Airport (MKY)",
  "Madinah Airport (MED)",
  "Madison Airport (MSN)",
  "Madrid Airport (MAD)",
  "Madurai Airport (IXM)",
  "Mae Hong Son Airport (HGN)",
  "Magadan Airport (GDX)",
  "Magnitogorsk Airport (MQF)",
  "Mahe Island Airport (SEZ)",
  "Maio Airport (MMO)",
  "Majunga Airport (MJN)",
  "Majuro Airport (MAJ)",
  "Malabo Airport (SSG)",
  "Malaga Airport (AGP)",
  "Malang Airport (MLG)",
  "Malatya Airport (MLX)",
  "Male Airport (MLE)",
  "Malindi Airport (MYD)",
  "Malmo Airport (MMX)",
  "Malta Airport (MLA)",
  "Mammoth Lakes Airport (MMH)",
  "Manado Airport (MDC)",
  "Managua Airport (MGA)",
  "Manaus Airport (MAO)",
  "Manchester Airport (MAN)",
  "Manchester Airport (MHT)",
  "Mandalay Airport (MDL)",
  "Mangalore Airport (IXE)",
  "Manhattan Airport (MHK)",
  "Manila Airport (MNL)",
  "Manizales Airport (MZL)",
  "Mannheim Airport (MHG)",
  "Manta Airport (MEC)",
  "Manzanillo Airport (ZLO)",
  "Manzini Airport (MTS)",
  "Maputo Airport (MPM)",
  "Mar del Plata Airport (MDQ)",
  "Mardin Airport (MQM)",
  "Maroantsetra Airport (WMN)",
  "Marquette Airport (MQT)",
  "Marrakech Airport (RAK)",
  "Marseille Airport (MRS)",
  "Marseille Airport (XRF)",
  "Marsh Harbour Airport (MHH)",
  "Martha's Vineyard Airport (MVY)",
  "Maseru Airport (MSU)",
  "Mashad Airport (MHD)",
  "Mason City Airport (MCW)",
  "Mataram Airport (AMI)",
  "Matsuyama Airport (MYJ)",
  "Maun Airport (MUB)",
  "Maupiti Island Airport (MAU)",
  "Mauritius Airport (MRU)",
  "Mazatlan Airport (MZT)",
  "McAllen Airport (MFE)",
  "McCook Airport (MCK)",
  "Medan Airport (MES)",
  "Medellin Airport (MDE)",
  "Medford Airport (MFR)",
  "Medicine Hat Airport (YXH)",
  "Meixian Airport (MXZ)",
  "Melbourne Airport (MEL)",
  "Melbourne Airport (MLB)",
  "Melilla Airport (MLN)",
  "Memmingen Airport (FMM)",
  "Memphis Airport (MEM)",
  "Mendoza Airport (MDZ)",
  "Menorca Airport (MAH)",
  "Merida Airport (MID)",
  "Meridian Airport (MEI)",
  "Mersa Matruh Airport (MUH)",
  "Metz Airport (XZI)",
  "Metz/Nancy Airport (ETZ)",
  "Mexicali Airport (MXL)",
  "Mexico City Airport (MEX)",
  "Mexico City Airport (TLC)",
  "Miami Airport (MIA)",
  "Midland/Odessa Airport (MAF)",
  "Mikonos Airport (JMK)",
  "Milan Airport (MXP)",
  "Milan Airport (LIN)",
  "Milan Airport (BGY)",
  "Milan Airport (PMF)",
  "Mildura Airport (MQL)",
  "Milos Airport (MLO)",
  "Milwaukee Airport (MKE)",
  "Minatitlan Airport (MTT)",
  "Mineralnye Vody Airport (MRV)",
  "Minneapolis/St Paul Airport (MSP)",
  "Minot Airport (MOT)",
  "Minsk Airport (MSQ)",
  "Miri Airport (MYY)",
  "Misawa Airport (MSJ)",
  "Missoula Airport (MSO)",
  "Miyako Jima Airport (MMY)",
  "Miyazaki Airport (KMI)",
  "Moab Airport (CNY)",
  "Mobile Airport (MOB)",
  "Modesto Airport (MOD)",
  "Molde Airport (MOL)",
  "Moline Airport (MLI)",
  "Mombasa Airport (MBA)",
  "Monastir Airport (MIR)",
  "Moncton Airport (YQM)",
  "Monroe Airport (MLU)",
  "Monrovia Airport (ROB)",
  "Montego Bay Airport (MBJ)",
  "Monterey Airport (MRY)",
  "Monteria Airport (MTR)",
  "Monterrey Airport (MTY)",
  "Montevideo Airport (MVD)",
  "Montgomery Airport (MGM)",
  "Montpellier Airport (MPL)",
  "Montpellier Airport (XPJ)",
  "Montreal Airport (YUL)",
  "Montrose Airport (MTJ)",
  "Montserrat Airport (MNI)",
  "Moorea Airport (MOZ)",
  "Morelia Airport (MLM)",
  "Morgantown Airport (MGW)",
  "Morondava Airport (MOQ)",
  "Moroni Airport (HAH)",
  "Moscow Airport (DME)",
  "Moscow Airport (VKO)",
  "Moscow Airport (SVO)",
  "Mount Isa Airport (ISA)",
  "Mount Pleasant Airport (MPN)",
  "Mudanjiang Airport (MDG)",
  "Mulu Airport (MZV)",
  "Mumbai Airport (BOM)",
  "Munda Airport (MUA)",
  "Munich Airport (MUC)",
  "Munster Airport (FMO)",
  "Murcia Airport (MJV)",
  "Murmansk Airport (MMK)",
  "Mus Airport (MSR)",
  "Muscat Airport (MCT)",
  "Muskegon Airport (MKG)",
  "Mwanza Airport (MWZ)",
  "Myrtle Beach Airport (MYR)",
  "Mysore Airport (MYQ)",
  "Mytilene Airport (MJT)",
  "Nadi Airport (NAN)",
  "Nador Airport (NDR)",
  "Nadym Airport (NYM)",
  "Nagasaki Airport (NGS)",
  "Nagoya Airport (NGO)",
  "Nagpur Airport (NAG)",
  "Nairobi Airport (NBO)",
  "Namangan Airport (NMA)",
  "Nanaimo Airport (YCD)",
  "Nanchang Airport (KHN)",
  "Nanjing Airport (NKG)",
  "Nanning Airport (NNG)",
  "Nantes Airport (NTE)",
  "Nantes Airport (QJZ)",
  "Nantucket Airport (ACK)",
  "Nanyang Airport (NNY)",
  "NapierAirport (Hastings Airport (NPE)",
  "Naples Airport (NAP)",
  "Nashville Airport (BNA)",
  "Nasik Airport (ISK)",
  "Nassau Airport (NAS)",
  "Natal Airport (NAT)",
  "Navegantes Airport (NVT)",
  "Naxos Is Airport (JNX)",
  "Ndola Airport (NLA)",
  "Neiva Airport (NVA)",
  "Nejran Airport (EAM)",
  "Nelson Airport (NSN)",
  "Nelspruit Airport (MQP)",
  "Nevis Airport (NEV)",
  "Nevsehir Airport (NAV)",
  "New Bern Airport (EWN)",
  "New Haven Airport (HVN)",
  "New Orleans Airport (MSY)",
  "New Plymouth Airport (NPL)",
  "New York Airport (JFK)",
  "New York Airport (LGA)",
  "New York Airport (EWR)",
  "Newburgh Airport (SWF)",
  "Newcastle Airport (NCL)",
  "Newcastle Airport (NTL)",
  "Newman Airport (ZNE)",
  "Newport News Airport (PHF)",
  "Newquay Airport (NQY)",
  "Nha Trang Airport (NHA)",
  "Nice Airport (NCE)",
  "Niigata Airport (KIJ)",
  "Nikolaev Airport (NLV)",
  "Ningbo Airport (NGB)",
  "Nizhnekamsk Airport (NBC)",
  "Nizhnevartovsk Airport (NJC)",
  "Nizhniy Novgorod Airport (GOJ)",
  "Norfolk Airport (ORF)",
  "Norrkoping Airport (NRK)",
  "Norsup Airport (NUS)",
  "North Bay Airport (YYB)",
  "North Bend Airport (OTH)",
  "North Eleuthera Airport (ELH)",
  "Norwich Airport (NWI)",
  "NossiAirport (Be Airport (NOS)",
  "Nottingham Airport (EMA)",
  "Nouakchott Airport (NKC)",
  "Noumea Airport (NOU)",
  "Novokuznetsk Airport (NOZ)",
  "Novosibirsk Airport (OVB)",
  "Novy Urengoy Airport (NUX)",
  "Nuevo Laredo Airport (NLD)",
  "Nuku Hiva Airport (NHV)",
  "Nuku'Alofa Airport (TBU)",
  "Nukus Airport (NCU)",
  "Nuremberg Airport (NUE)",
  "Oakland Airport (OAK)",
  "Oaxaca Airport (OAX)",
  "Obihiro Airport (OBO)",
  "Odessa Airport (ODS)",
  "Ohrid Airport (OHD)",
  "Oita Airport (OIT)",
  "Okayama Airport (OKJ)",
  "Okinawa Airport (OKA)",
  "Oklahoma City Airport (OKC)",
  "Olbia Airport (OLB)",
  "Olympic Dam Airport (OLP)",
  "Omaha Airport (OMA)",
  "Omsk Airport (OMS)",
  "Ontario Airport (ONT)",
  "Oradea Airport (OMR)",
  "Oran Airport (ORN)",
  "Orenburg Airport (REN)",
  "Orlando Airport (MCO)",
  "Orsk Airport (OSW)",
  "Osaka Airport (KIX)",
  "Osaka Airport (ITM)",
  "Osaka Airport (UKB)",
  "Osh Airport (OSS)",
  "Oslo Airport (OSL)",
  "Oslo Airport (TRF)",
  "Oslo Airport (RYG)",
  "Osorno Airport (ZOS)",
  "Ostersund Airport (OSD)",
  "Ostrava Airport (OSR)",
  "Ottawa Airport (YOW)",
  "Ouagadougou Airport (OUA)",
  "Ouarzazate Airport (OZZ)",
  "Oujda Airport (OUD)",
  "Oulu Airport (OUL)",
  "Ovda Airport (VDA)",
  "Padang Airport (PDG)",
  "Paderborn Airport (PAD)",
  "Paducah Airport (PAH)",
  "Page Airport (PGA)",
  "Pago Pago Airport (PPG)",
  "Pakse Airport (PKZ)",
  "Palangkaraya Airport (PKY)",
  "Palembang Airport (PLM)",
  "Palermo Airport (PMO)",
  "Palm Springs Airport (PSP)",
  "Palma Mallorca Airport (PMI)",
  "Palmas Airport (PMW)",
  "Palmerston North Airport (PMR)",
  "Pamplona Airport (PNA)",
  "Panama City Airport (PTY)",
  "Panama City Airport (PAC)",
  "Panama City Airport (PFN)",
  "Pantelleria Airport (PNL)",
  "Papeete Airport (PPT)",
  "Paphos Airport (PFO)",
  "Paramaribo Airport (PBM)",
  "Paris Airport (CDG)",
  "Paris Airport (ORY)",
  "Paris Airport (BVA)",
  "Paros Airport (PAS)",
  "Pasco Airport (PSC)",
  "Pasto Airport (PSO)",
  "Patna Airport (PAT)",
  "Patras Airport (GPA)",
  "Pau Airport (PUF)",
  "Pavlodar Airport (PWQ)",
  "Pekanbaru Airport (PKU)",
  "Pellston Airport (PLN)",
  "Pemba Airport (POL)",
  "Penang Airport (PEN)",
  "Pensacola Airport (PNS)",
  "Peoria Airport (PIA)",
  "Pereira Airport (PEI)",
  "Perigueux Airport (PGX)",
  "Perm Airport (PEE)",
  "Perpignan Airport (PGF)",
  "Perth Airport (PER)",
  "Perugia Airport (PEG)",
  "Pescara Airport (PSR)",
  "Peshawar Airport (PEW)",
  "Petrolina Airport (PNZ)",
  "PetropavlovskAirport (Kamchats Airport (PKC)",
  "Phalaborwa Airport (PHW)",
  "Philadelphia Airport (PHL)",
  "Phitsanulok Airport (PHS)",
  "Phnom Penh Airport (PNH)",
  "Phoenix Airport (PHX)",
  "Phuket Airport (HKT)",
  "Phuquoc Airport (PQC)",
  "Pico Island Airport (PIX)",
  "Pietermaritzburg Airport (PZB)",
  "Pisa Airport (PSA)",
  "Pittsburgh Airport (PIT)",
  "Piura Airport (PIU)",
  "Plattsburgh Airport (PBG)",
  "Pleiku Airport (PXU)",
  "Plymouth Airport (PLH)",
  "Pocatello Airport (PIH)",
  "Podgorica Airport (TGD)",
  "Pohang Airport (KPO)",
  "Pohnpei Airport (PNI)",
  "Pointe Noire Airport (PNR)",
  "PointeAirport (aAirport (Pitre Airport (PTP)",
  "Poitiers Airport (PIS)",
  "Poitiers Airport (XOP)",
  "Polokwane Airport (PTG)",
  "Ponta Delgada Airport (PDL)",
  "Pontianak Airport (PNK)",
  "Popayan Airport (PPN)",
  "Poprad/Tatry Airport (TAT)",
  "Porbandar Airport (PBD)",
  "Porlamar Airport (PMV)",
  "Port au Prince Airport (PAP)",
  "Port Blair Airport (IXZ)",
  "Port Elizabeth Airport (PLZ)",
  "Port Harcourt Airport (PHC)",
  "Port Hedland Airport (PHE)",
  "Port Lincoln Airport (PLO)",
  "Port Macquarie Airport (PQQ)",
  "Port Moresby Airport (POM)",
  "Port of Spain Airport (POS)",
  "Port Vila Airport (VLI)",
  "Portland Airport (PWM)",
  "Portland Airport (PDX)",
  "Porto Airport (OPO)",
  "Porto Alegre Airport (POA)",
  "Porto Santo Airport (PXO)",
  "Porto Seguro Airport (BPS)",
  "Porto Velho Airport (PVH)",
  "Posadas Airport (PSS)",
  "Poza Rica Airport (PAZ)",
  "Poznan Airport (POZ)",
  "Prague Airport (PRG)",
  "Praia Airport (RAI)",
  "Praslin Island Airport (PRI)",
  "Presque Isle Airport (PQI)",
  "Preveza/Lefkas Airport (PVK)",
  "Prince George Airport (YXS)",
  "Pristina Airport (PRN)",
  "Proserpine Airport (PPP)",
  "Providence Airport (PVD)",
  "Providenciales Airport (PLS)",
  "Pucallpa Airport (PCL)",
  "Puebla Airport (PBC)",
  "Puerto Escondido Airport (PXM)",
  "Puerto Maldonado Airport (PEM)",
  "Puerto Montt Airport (PMC)",
  "Puerto Plata Airport (POP)",
  "Puerto Vallarta Airport (PVR)",
  "Pula Airport (PUY)",
  "Pullman Airport (PUW)",
  "Pune Airport (PNQ)",
  "Punta Arenas Airport (PUQ)",
  "Punta Cana Airport (PUJ)",
  "Punta Del Este Airport (PDP)",
  "Qingdao Airport (TAO)",
  "Qiqihar Airport (NDG)",
  "Quebec Airport (YQB)",
  "Queenstown Airport (ZQN)",
  "Quelimane Airport (UEL)",
  "Queretaro Airport (QRO)",
  "Quesnel Airport (YQZ)",
  "Quetta Airport (UET)",
  "Quimper Airport (UIP)",
  "Quinhon Airport (UIH)",
  "Quito Airport (UIO)",
  "Rabat Airport (RBA)",
  "Rachgia Airport (VKG)",
  "Raiatea Island Airport (RFP)",
  "Raipur Airport (RPR)",
  "Rajahmundry Airport (RJA)",
  "Rajkot Airport (RAJ)",
  "Raleigh/Durham Airport (RDU)",
  "Ranchi Airport (IXR)",
  "Rangiroa Island Airport (RGI)",
  "Rapid City Airport (RAP)",
  "Rarotonga Airport (RAR)",
  "Recife Airport (REC)",
  "Redding Airport (RDD)",
  "Redmond Airport (RDM)",
  "Reggio Calabria Airport (REG)",
  "Regina Airport (YQR)",
  "Rennes Airport (RNS)",
  "Reno Airport (RNO)",
  "Reus Airport (REU)",
  "Reykjavik Airport (KEF)",
  "Reynosa Airport (REX)",
  "Rhodes Airport (RHO)",
  "Ribeirao Preto Airport (RAO)",
  "Richards Bay Airport (RCB)",
  "Richmond Airport (RIC)",
  "Riga Airport (RIX)",
  "Rijeka Airport (RJK)",
  "Rimini Airport (RMI)",
  "Rio Branco Airport (RBR)",
  "Rio de Janeiro Airport (SDU)",
  "Rio de Janeiro Airport (GIG)",
  "Rio Gallegos Airport (RGL)",
  "Riohacha Airport (RCH)",
  "Riverton Airport (RIW)",
  "Riyadh Airport (RUH)",
  "Roanoke Airport (ROA)",
  "Roatan Airport (RTB)",
  "Rochester Airport (ROC)",
  "Rochester Airport (RST)",
  "Rock Sound Airport (RSD)",
  "Rock Springs Airport (RKS)",
  "Rockhampton Airport (ROK)",
  "Rodez Airport (RDZ)",
  "Rodrigues Island Airport (RRG)",
  "Rome Airport (FCO)",
  "Rome Airport (CIA)",
  "Ronneby Airport (RNB)",
  "Rosario Airport (ROS)",
  "RostockAirport (Laage Airport (RLG)",
  "Rostov Airport (ROV)",
  "Roswell Airport (ROW)",
  "Rotorua Airport (ROT)",
  "Rotterdam Airport (RTM)",
  "Rovaniemi Airport (RVN)",
  "Rzeszow Airport (RZE)",
  "Saarbrucken Airport (SCN)",
  "Saba Airport (SAB)",
  "Sacramento Airport (SMF)",
  "Saginaw Airport (MBS)",
  "Saipan Airport (SPN)",
  "Sal Airport (SID)",
  "Salalah Airport (SLL)",
  "Salamanca Airport (SLM)",
  "SalisburyAirport (Ocean City Airport (SBY)",
  "Salt Lake City Airport (SLC)",
  "Salta Airport (SLA)",
  "Saltillo Airport (SLW)",
  "Salvador Airport (SSA)",
  "Salzburg Airport (SZG)",
  "Samana Airport (AZS)",
  "Samara Airport (KUF)",
  "Samarkand Airport (SKD)",
  "Samos Airport (SMI)",
  "Samsun Airport (SZF)",
  "San Andres Island Airport (ADZ)",
  "San Angelo Airport (SJT)",
  "San Antonio Airport (SAT)",
  "San Carlos de Bariloche Airport (BRC)",
  "San Diego Airport (SAN)",
  "San Diego Airport (CLD)",
  "San Francisco Airport (SFO)",
  "San Jose Airport (SJO)",
  "San Jose Airport (SJC)",
  "San Jose Cabo Airport (SJD)",
  "San Juan Airport (SJU)",
  "San Luis Airport (LUQ)",
  "San Luis Obispo Airport (SBP)",
  "San Luis Potosi Airport (SLP)",
  "San Pedro Sula Airport (SAP)",
  "San Salvador Airport (SAL)",
  "San Salvador Airport (ZSA)",
  "San Sebastian Airport (EAS)",
  "San Sebastian de la Gomera Airport (GMZ)",
  "Sanaa Airport (SAH)",
  "Sandakan Airport (SDK)",
  "Sandspit Airport (YZP)",
  "Santa Ana Airport (SNA)",
  "Santa Barbara Airport (SBA)",
  "Santa Cruz Airport (VVI)",
  "Santa Cruz de la Palma Airport (SPC)",
  "Santa Fe Airport (SAF)",
  "Santa Fe Airport (SFN)",
  "Santa Maria Airport (SMX)",
  "Santa Maria Airport (SMA)",
  "Santa Marta Airport (SMR)",
  "Santa Rosa Airport (STS)",
  "Santander Airport (SDR)",
  "Santarem Airport (STM)",
  "Santiago Airport (SCL)",
  "Santiago Airport (STI)",
  "Santiago de Compostela Airport (SCQ)",
  "Santo Domingo Airport (SDQ)",
  "Sanya Airport (SYX)",
  "Sao Filipe Airport (SFL)",
  "Sao Jorge Island Airport (SJZ)",
  "Sao Jose Do Rio Preto Airport (SJP)",
  "Sao Luiz Airport (SLZ)",
  "Sao Nicolau Airport (SNE)",
  "Sao Paulo Airport (CGH)",
  "Sao Paulo Airport (VCP)",
  "Sao Paulo Airport (GRU)",
  "Sao Tome Island Airport (TMS)",
  "Sao Vicente Airport (VXE)",
  "Sapporo Airport (CTS)",
  "Sarajevo Airport (SJJ)",
  "Sarasota/Bradenton Airport (SRQ)",
  "Sarnia Airport (YZR)",
  "Saskatoon Airport (YXE)",
  "Satu Mare Airport (SUJ)",
  "Sault Ste Marie Airport (YAM)",
  "Sault Ste Marie Airport (CIU)",
  "Savannah Airport (SAV)",
  "Savannakhet Airport (ZVK)",
  "Savusavu Airport (SVU)",
  "Seattle Airport (SEA)",
  "Semarang Airport (SRG)",
  "Sendai Airport (SDJ)",
  "Seoul Airport (GMP)",
  "Seoul Airport (ICN)",
  "SeptAirport (Iles Airport (YZV)",
  "Setif Airport (QSF)",
  "Seville Airport (SVQ)",
  "Sfax Airport (SFA)",
  "Shamshabad Airport (HYD)",
  "Shanghai Airport (PVG)",
  "Shanghai Airport (SHA)",
  "Shannon Airport (SNN)",
  "Shantou Airport (SWA)",
  "Sharjah Airport (SHJ)",
  "Sharm El Sheikh Airport (SSH)",
  "Shenyang Airport (SHE)",
  "Shenzhen Airport (SZX)",
  "Sheridan Airport (SHR)",
  "Shetland Islands Airport (LSI)",
  "Shijiazhuang Airport (SJW)",
  "Shimkent Airport (CIT)",
  "Shiraz Airport (SYZ)",
  "Shreveport Airport (SHV)",
  "Sibiu Airport (SBZ)",
  "Sibu Airport (SBW)",
  "Siem Reap Airport (REP)",
  "Silchar Airport (IXS)",
  "Simao Airport (SYM)",
  "Simferopol Airport (SIP)",
  "Simla Airport (SLV)",
  "Singapore Airport (SIN)",
  "Singapore Airport (XSP)",
  "Sioux City Airport (SUX)",
  "Sioux Falls Airport (FSD)",
  "Sitia Airport (JSH)",
  "Sitka Airport (SIT)",
  "Sivas Airport (VAS)",
  "Skelleftea Airport (SFT)",
  "Skiathos Airport (JSI)",
  "Skopje Airport (SKP)",
  "Sligo Airport (SXL)",
  "Smithers Airport (YYD)",
  "Sofia Airport (SOF)",
  "Solo City Airport (SOC)",
  "Sonderborg Airport (SGD)",
  "South Bend Airport (SBN)",
  "Southampton Airport (SOU)",
  "Southend Airport (SEN)",
  "Split Airport (SPU)",
  "Spokane Airport (GEG)",
  "Springfield Airport (SPI)",
  "Springfield Airport (SGF)",
  "Srinagar Airport (SXR)",
  "St Barthelemy Airport (SBH)",
  "St Croix Island Airport (STX)",
  "St Denis de la Reunion Airport (RUN)",
  "St Etienne Airport (EBU)",
  "St Eustatius Airport (EUX)",
  "St George Airport (SGU)",
  "St John Airport (YSJ)",
  "St Johns Airport (YYT)",
  "St Kitts Airport (SKB)",
  "St Louis Airport (STL)",
  "St Lucia Airport (SLU)",
  "St Lucia Airport (UVF)",
  "St Maarten Airport (SXM)",
  "St Martin Airport (SFG)",
  "St Petersburg Airport (LED)",
  "St Pierre de la Reunion Airport (ZSE)",
  "St Thomas Island Airport (STT)",
  "St Tropez Airport (LTT)",
  "St Vincent Airport (SVD)",
  "State College Airport (SCE)",
  "Staunton Airport (SHD)",
  "Stavanger Airport (SVG)",
  "Stavropol Airport (STW)",
  "Ste Marie Airport (SMS)",
  "Steamboat Springs Airport (HDN)",
  "Stockholm Airport (ARN)",
  "Stockholm Airport (BMA)",
  "Stockholm Airport (NYO)",
  "Stockholm Airport (VST)",
  "Stornoway Airport (SYY)",
  "Strasbourg Airport (SXB)",
  "Strasbourg Airport (XWG)",
  "Stuttgart Airport (STR)",
  "Suceava Airport (SCV)",
  "Sucre Airport (SRE)",
  "Sudbury Airport (YSB)",
  "Sukhothai Airport (THS)",
  "Sun Valley Airport (SUN)",
  "Sundsvall Airport (SDL)",
  "Sunshine Coast Airport (MCY)",
  "Surabaya Airport (SUB)",
  "Surat Thani Airport (URT)",
  "Surgut Airport (SGC)",
  "Suva Airport (SUV)",
  "Sydney Airport (SYD)",
  "Sydney Airport (YQY)",
  "Syktyvkar Airport (SCW)",
  "Sylhet Airport (ZYL)",
  "Syracuse Airport (SYR)",
  "Syros Island Airport (JSY)",
  "Szczecin Airport (SZZ)",
  "Taba Airport (TCP)",
  "Tabriz Airport (TBZ)",
  "Tabuk Airport (TUU)",
  "Tacna Airport (TCQ)",
  "Taichung Airport (RMQ)",
  "Taif Airport (TIF)",
  "Taipei Airport (TPE)",
  "Taipei Airport (TSA)",
  "Taiyuan Airport (TYN)",
  "Takamatsu Airport (TAK)",
  "Tallahassee Airport (TLH)",
  "Tallinn Airport (TLL)",
  "Tamanrasset Airport (TMR)",
  "Tamatave Airport (TMM)",
  "Tampa Airport (TPA)",
  "Tampere Airport (TMP)",
  "Tampico Airport (TAM)",
  "Tamworth Airport (TMW)",
  "Tan Tan Airport (TTA)",
  "Tangier Airport (TNG)",
  "Tapachula Airport (TAP)",
  "Tarapoto Airport (TPP)",
  "Tarawa Airport (TRW)",
  "Tarija Airport (TJA)",
  "Tartu Airport (TAY)",
  "Tashkent Airport (TAS)",
  "Taupo Airport (TUO)",
  "Tauranga Airport (TRG)",
  "Taveuni Airport (TVU)",
  "Tawau Airport (TWU)",
  "Tbilisi Airport (TBS)",
  "Tegucigalpa Airport (TGU)",
  "Tel Aviv Airport (TLV)",
  "Telluride Airport (TEX)",
  "Temuco Airport (ZCO)",
  "Tenerife Airport (TFS)",
  "Tenerife Airport (TFN)",
  "Tepic Airport (TPQ)",
  "Terceira Airport (TER)",
  "Teresina Airport (THE)",
  "Ternate Airport (TTE)",
  "Tete Airport (TET)",
  "Texarkana Airport (TXK)",
  "Thessaloniki Airport (SKG)",
  "Thief River Falls Airport (TVF)",
  "Thira Airport (JTR)",
  "Thiruvananthapuram Airport (TRV)",
  "Thunder Bay Airport (YQT)",
  "Tianjin Airport (TSN)",
  "Tijuana Airport (TIJ)",
  "Tikehau Atoll Airport (TIH)",
  "Timaru Airport (TIU)",
  "Timisoara Airport (TSR)",
  "Timmins Airport (YTS)",
  "Tindouf Airport (TIN)",
  "Tioman Airport (TOD)",
  "Tirana Airport (TIA)",
  "Tiree Airport (TRE)",
  "Tirgu Mures Airport (TGM)",
  "Tiruchirapally Airport (TRZ)",
  "Tirupati Airport (TIR)",
  "Tivat Airport (TIV)",
  "Tlemcen Airport (TLM)",
  "Tobago Airport (TAB)",
  "Tokushima Airport (TKS)",
  "Tokyo Airport (NRT)",
  "Tokyo Airport (HND)",
  "Toledo Airport (TOL)",
  "Tomsk Airport (TOF)",
  "Toronto Airport (YYZ)",
  "Toronto Airport (YHM)",
  "Toronto Airport (YTZ)",
  "Torreon Airport (TRC)",
  "Tottori Airport (TTJ)",
  "Toulon Airport (TLN)",
  "Toulouse Airport (TLS)",
  "Tours Airport (TUF)",
  "Townsville Airport (TSV)",
  "Toyama Airport (TOY)",
  "Tozeur Airport (TOE)",
  "Trabzon Airport (TZX)",
  "Trapani Airport (TPS)",
  "Trat Airport (TDX)",
  "Traverse City Airport (TVC)",
  "Treasure Cay Airport (TCB)",
  "Trelew Airport (REL)",
  "TriAirport (Cities Regional Airport (TRI)",
  "Trieste Airport (TRS)",
  "Tripoli Airport (TIP)",
  "Tromso Airport (TOS)",
  "Trondheim Airport (TRD)",
  "Trujillo Airport (TRU)",
  "Tucson Airport (TUS)",
  "Tucuman Airport (TUC)",
  "Tulear Airport (TLE)",
  "Tulsa Airport (TUL)",
  "Tumaco Airport (TCO)",
  "Tumbes Airport (TBP)",
  "Tunis Airport (TUN)",
  "Tunxi Airport (TXN)",
  "Turaif Airport (TUI)",
  "Turin Airport (TRN)",
  "Turku Airport (TKU)",
  "Tuxtla Gutierrez Airport (TGZ)",
  "Twin Falls Airport (TWF)",
  "Tyler Airport (TYR)",
  "Tyumen Airport (TJM)",
  "Uberlandia Airport (UDI)",
  "Ubon Ratchathani Airport (UBP)",
  "Udaipur Airport (UDR)",
  "Udon Thani Airport (UTH)",
  "Ufa Airport (UFA)",
  "Ujung Pandang Airport (UPG)",
  "Ukhta Airport (UCT)",
  "Ulaanbaatar Airport (ULN)",
  "UlanAirport (Ude Airport (UUD)",
  "Ulsan Airport (USN)",
  "Ulyanovsk Airport (ULY)",
  "Umea Airport (UME)",
  "Umtata Airport (UTT)",
  "Upington Airport (UTN)",
  "Uralsk Airport (URA)",
  "Urgench Airport (UGC)",
  "Urumqi Airport (URC)",
  "Ushuaia Airport (USH)",
  "Usinsk Airport (USK)",
  "UstAirport (Kamenogorsk Airport (UKK)",
  "UstAirport (Kut Airport (UKX)",
  "Utapao Airport (UTP)",
  "Uzhgorod Airport (UDJ)",
  "Vaasa Airport (VAA)",
  "Vadodara Airport (BDQ)",
  "Vail Airport (EGE)",
  "Valdivia Airport (ZAL)",
  "Valdosta Airport (VLD)",
  "Valencia Airport (VLC)",
  "Valencia Airport (VLN)",
  "Valladolid Airport (VLL)",
  "Valledupar Airport (VUP)",
  "Valparaiso Airport (VPS)",
  "Valverde Airport (VDE)",
  "Van Airport (VAN)",
  "Vancouver Airport (YVR)",
  "Varanasi Airport (VNS)",
  "Varna Airport (VAR)",
  "Vaxjo Airport (VXO)",
  "Venice Airport (VCE)",
  "Venice Airport (TSF)",
  "Veracruz Airport (VER)",
  "Verona Airport (VRN)",
  "Victoria Airport (YYJ)",
  "Victoria Falls Airport (VFA)",
  "Vienna Airport (VIE)",
  "Vientiane Airport (VTE)",
  "Vieques Airport (VQS)",
  "Vigo Airport (VGO)",
  "Vijayawada Airport (VGA)",
  "Vilanculos Airport (VNX)",
  "Villahermosa Airport (VSA)",
  "Vilnius Airport (VNO)",
  "Vinh City Airport (VII)",
  "Visby Airport (VBY)",
  "Vishakhapatnam Airport (VTZ)",
  "Vitoria Airport (VIX)",
  "Vitoria Airport (VIT)",
  "Vladikavkaz Airport (OGZ)",
  "Vladivostok Airport (VVO)",
  "Volgograd Airport (VOG)",
  "Volos Airport (VOL)",
  "Voronezh Airport (VOZ)",
  "Wabush Airport (YWK)",
  "Waco Airport (ACT)",
  "Wagga Wagga Airport (WGA)",
  "Walla Walla Airport (ALW)",
  "Wallis Island Airport (WLS)",
  "Walvis Bay Airport (WVB)",
  "Wanaka Airport (WKA)",
  "Wanganui Airport (WAG)",
  "Warsaw Airport (WAW)",
  "Washington Airport (IAD)",
  "Washington Airport (DCA)",
  "Waterford Airport (WAT)",
  "Waterloo Airport (ALO)",
  "Watertown Airport (ATY)",
  "Wausau Airport (CWA)",
  "Weihai Airport (WEH)",
  "Weipa Airport (WEI)",
  "Wellington Airport (WLG)",
  "Wenatchee Airport (EAT)",
  "Wenzhou Airport (WNZ)",
  "West Palm Beach Airport (PBI)",
  "West Yellowstone Airport (WYS)",
  "Westchester County Airport (HPN)",
  "Westerland Airport (GWT)",
  "Whakatane Airport (WHK)",
  "Whangarei Airport (WRE)",
  "Whitehorse Airport (YXY)",
  "Wichita Airport (ICT)",
  "Wichita Falls Airport (SPS)",
  "Wick Airport (WIC)",
  "WilkesAirport (Barre Airport (AVP)",
  "Williamsport Airport (IPT)",
  "Williston Airport (ISN)",
  "Wilmington Airport (ILM)",
  "Windhoek Airport (WDH)",
  "Windsor Airport (YQG)",
  "Winnipeg Airport (YWG)",
  "Worland Airport (WRL)",
  "Wroclaw Airport (WRO)",
  "Wuhan Airport (WUH)",
  "Wuxi Airport (WUX)",
  "Xi an Airport (XIY)",
  "Xiamen Airport (XMN)",
  "Xiangfan Airport (XFN)",
  "Xieng Khouang Airport (XKH)",
  "Xilinhot Airport (XIL)",
  "Xining Airport (XNN)",
  "Xuzhou Airport (XUZ)",
  "Yakima Airport (YKM)",
  "Yakutsk Airport (YKS)",
  "Yanbu Airport (YNB)",
  "Yangon Airport (RGN)",
  "Yanji Airport (YNJ)",
  "Yantai Airport (YNT)",
  "Yaounde Airport (NSI)",
  "Yellowknife Airport (YZF)",
  "Yerevan Airport (EVN)",
  "Yibin Airport (YBP)",
  "Yichang Airport (YIH)",
  "Yinchuan Airport (INC)",
  "Yiwu Airport (YIW)",
  "Yogyakarta Airport (JOG)",
  "Yonago Airport (YGJ)",
  "Yuma Airport (YUM)",
  "Yun Cheng Airport (YCU)",
  "YuzhnoAirport (Sakhalinsk Airport (UUS)",
  "Zacatecas Airport (ZCL)",
  "Zadar Airport (ZAD)",
  "Zagreb Airport (ZAG)",
  "Zakinthos Airport (ZTH)",
  "Zanzibar Airport (ZNZ)",
  "Zaporozhye Airport (OZH)",
  "Zaragoza Airport (ZAZ)",
  "Zhanjiang Airport (ZHA)",
  "Zhengzhou Airport (CGO)",
  "Zhuhai Airport (ZUH)",
  "Zilina Airport (ILZ)",
  "Zurich Airport (ZRH)",
];
